import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles((theme) => ({
  primary: {
    color: theme.palette.primary.main,
  },
  secondary: {
    color: theme.palette.purple.main,
  },
  success: {
    color: theme.palette.green.main,
  },
  warning: {
    color: theme.palette.red.main,
  },
  error: {
    color: theme.palette.red.main,
  },
  blue: {
    color: theme.palette.blue.main,
  },
  purple: {
    color: theme.palette.purple.main,
  },
  green: {
    color: theme.palette.green.main,
  },
  orange: {
    color: theme.palette.orange.main,
  },
  red: {
    color: theme.palette.red.main,
  },
  black: {
    color: theme.palette.black.main,
  },
  grey: {
    color: theme.palette.grey.main,
  },
}));

export default styles;
